{
  "ru": {
    "arrival": "Куда",
    "departure": "Откуда"
  },
  "kk": {
    "arrival": "Қайда",
    "departure": "Қайдан"
  },
  "en": {
    "arrival": "Where",
    "departure": "From where"
  }
}
